/**
 * FM マップページのルートコンポーネント
 */
import { defineComponent, onMounted } from 'vue'
import MapPage from "@/organizations/_default/map"

export default defineComponent({
  extends: MapPage,
  setup(props, context) {
    const page = MapPage.setup(props, context)
    const is_new_open = storelocator?.path?.id == "new-open"

    onMounted(() => {
      // 新着店舗表示の場合、タイトルを追加
      if (is_new_open) {
        const h1 = document.querySelector('h1')
        if (h1) {
          const p = document.createElement('p')
          p.textContent = storelocator.messages.new_open_map_title
          p.classList.add('new-open-map-title')
          h1.appendChild(p)
        }
      }
    })

    return {
      ...page,
    }
  }
})